module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sliderArg.flag),
      expression: "sliderArg.flag"
    }],
    ref: "slider",
    staticClass: "wrap",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.close($event)
      }
    }
  }, [_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "head"
  }, [_vm._v(_vm._s(_vm.title || ""))]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "inside-page",
    class: {
      open: _vm.sliderArg.inside_index == 0 && _vm.sliderArg.insideFlag == true
    }
  }, [_vm._t("pass")], 2), _vm._v(" "), _c('div', {
    staticClass: "inside-page",
    class: {
      open: _vm.sliderArg.inside_index == 1 && _vm.sliderArg.insideFlag == true
    }
  }, [_vm._t("notpass")], 2)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-176a3509!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/sliderPage.vue
// module id = 698
// module chunks = 1